import React from "react";
import {
  Paper,
  Typography,
  Box,
  Stack,
  Button,
} from "@mui/material";
import PolicyBadges from "../../pages/vendor/PolicyBadges";

const BuyBox = ({
  price,
  pincode,
  setPincode,
  deliveryEta,
  setDeliveryEta,
  qty,
  setQty,
  handleAddToCart,
  handleBuyNow,
  product,
  badges,
  navigate,
  businessName,
  vendor,
  vendorName,
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 3,
        position: { md: "sticky" },
        top: 80,
      }}
    >
      <Typography variant="h6" fontWeight={700}>
        ₹ {Number(price).toLocaleString("en-IN")}
      </Typography>

      <PolicyBadges badges={badges} singleLine={true} />

      <Stack spacing={1.5} sx={{ mt: 2 }}>
        {/* Quantity Selector */}
        <Box sx={{ mt: 2 }}>
            <Typography fontWeight={600} mb={0.5}>
              Quantity:
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                size="small"
                variant="outlined"
                onClick={() => setQty(Math.max(1, (Number(qty) || 1) - 1))}
                disabled={qty <= 1}
                sx={{ minWidth: 32, height: 32, borderColor: "#ccc", fontWeight: 700, fontSize: 16 }}
              >
                −
              </Button>
              <input
                type="number"
                min={1}
                value={qty}
                onChange={(e) => {
                  const raw = e.target.value.replace(/[^0-9]/g, "");
                  setQty(raw === "" ? "" : Number(raw));
                }}
                onBlur={() => setQty((prev) => (Number(prev) > 0 ? Number(prev) : 1))}
                style={{
                  width: 64,
                  textAlign: "center",
                  padding: "6px",
                  borderRadius: 4,
                  border: "1px solid #ccc",
                  background: "#f0f2f2",
                }}
              />
              <Button
                size="small"
                variant="outlined"
                onClick={() => setQty((Number(qty) || 0) + 1)}
                sx={{ minWidth: 32, height: 32, borderColor: "#ccc", fontWeight: 700, fontSize: 16 }}
              >
                +
              </Button>
            </Box>
          </Box>

        <Button
          type="button"
          variant="contained"
          sx={{
            bgcolor: "#ffd814",
            color: "#000",
            fontWeight: 600,
          }}
          onClick={handleAddToCart}
        >
          Add to Cart
        </Button>

        <Button
          variant="contained"
          sx={{
            bgcolor: "#ffa41c",
            color: "#000",
            fontWeight: 600,
          }}
          onClick={handleBuyNow}
        >
          Buy Now
        </Button>
      </Stack>

      <Typography variant="caption" sx={{ mt: 2, display: "block" }}>
        Sold by{" "}
        <span
          onClick={() => navigate(`/store/${product.vendorId}`)}
          style={{
            color: "#007185",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {businessName ||
            vendor?.store?.businessName ||
            vendor?.businessName ||
            product?.vendor?.businessName ||
            vendorName}
        </span>
      </Typography>
    </Paper>
  );
};

export default BuyBox;